import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationHeader from '../../components/navigation/NavigationHeader';
import FileUploader from '../../components/commos/FileUploader';
import { hideGlobalModal, showGlobalModal } from '../../stores/modalStore';
import { useAlertStore } from '../../stores/alertStore';
import { useRulesStore } from '../../stores/rulesStore';
import { useAuthStore } from '../../features/sso-auth/store/authStore';
import ButtonDownloadTemplate from '../../components/ButtonDownloadTemplate';
import { validateExcelHeaders } from '../../utils/excel';


const REQUIRED_FIELDS = ['name', 'type', 'template'];


async function validateRulesFields(file: File, showAlert: (a: any) => void): Promise<boolean> {
  return validateExcelHeaders(file, REQUIRED_FIELDS, showAlert);
}


const RulesPage: React.FC = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlertStore();
  const { saveRule } = useRulesStore();
  const { user } = useAuthStore();


  const handleUpload = useCallback(
    async (file: File) => {
      const isValid = await validateRulesFields(file, showAlert);
      if (!isValid) return;

      showGlobalModal({
        title: '¿Confirmar la creación de nuevas Reglas?',
        message:
          'Estás a punto de crear nuevas Reglas. Una vez guardadas, quedarán almacenadas en la librería de Reglas.',
        iconType: 'warning',
        primaryAction: {
          label: 'Guardar',
          onClick: () => {
            void (async () => {
              const data = await saveRule({ file, country: user?.country_code || '' });
              if (data.success) {
                showAlert({
                  text: 'Regla guardada exitosamente',
                  message: `La regla "${file.name}" ha sido guardada en la librería`,
                  status: 'success',
                });
                void navigate('table');
              } else {
                showAlert({
                  text: 'Error al guardar regla',
                  message: data.message,
                  status: 'error',
                });
              }
              hideGlobalModal();
            })();
          },
          variant: 'primary',
        },
        secondaryAction: {
          label: 'Cancelar',
          onClick: () => {
            hideGlobalModal();
          },
        },
      });
    },
    [navigate, saveRule, showAlert, user]
  );

  return (
    <div className="min-h-screen bg-gray-100">
      <NavigationHeader
        title="Creación de reglas"
        description="Aquí podrás crear y personalizar tus reglas para la implementación de los combos."
        backLink="/"
        actions={[
          <ButtonDownloadTemplate key="download-template" fileName="TemplateRules.xlsx" />
        ]}
      />
      <div className="container mx-auto px-4 py-8">
        <div className="border bg-white rounded-lg shadow-md p-6">
          <h2 className="text-l font-bold">Cargar Excel con Reglas</h2>
          <FileUploader
            title="Carga tu archivo aquí"
            description="Selecciona un archivo de reglas para cargar"
            onUpload={handleUpload}
            acceptedFileTypes=".xlsx,.xls"
          />
        </div>
      </div>
    </div>
  );
};

export default RulesPage;
